import styled from 'styled-components';
import { Absolute, Box } from 'pcln-design-system';
export const LoadMorePromptsWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "ChatContentstyles__LoadMorePromptsWrapper",
  componentId: "sc-xg0mlj-0"
})(["text-align:center;display:inline-flex;justify-content:center;margin-bottom:20px;margin-top:14px;"]);
export const LoadMorePrompts = /*#__PURE__*/styled(Box).withConfig({
  displayName: "ChatContentstyles__LoadMorePrompts",
  componentId: "sc-xg0mlj-1"
})(["cursor:pointer;"]);
export const ToastWrapper = /*#__PURE__*/styled(Absolute).withConfig({
  displayName: "ChatContentstyles__ToastWrapper",
  componentId: "sc-xg0mlj-2"
})(["width:300px;left:50%;transform:translate(-50%,-50%);top:40px;"]);